import React from 'react';
import Grid from 'material-ui/Grid';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import { store } from '../../../redux/store/configureStore';
import { Accordion } from '../../molecules/Accordion';
import Timeline from '../../molecules/Timeline';
import Feedback from '../../atoms/Feedback';
import InfoMessage from '../../atoms/InfoMessage';
import {
  MissingItemsAccordionContents,
  YourItemsAccordionContents,
  OrderSummaryAccordionContents,
} from '../../molecules/AccordionContents';
import { getOrderDetails } from '../../../redux/actions/orderActions';
import LoadingSpinner from '../../atoms/LoadingSpinner';
import { randomStr } from '../../../configs/helpers';

export class OrderDetail extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
    };
    this.getFeedback = this.getFeedback.bind(this);
  }

  componentWillMount() {
    this.props.getOrderDetails(this.props.params.transactionId);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      loading: false,
    });
    this.props.getStatus(nextProps.orderDetails.status);
    if (nextProps.orderDetails.status === 'Enroute') {
      this.props.getTime(nextProps.orderDetails.expectedDeliveryTime);
    }
  }

  getFeedback() {
    if (this.props && this.props.orderDetails && this.props.orderDetails.status === 'Delivered') {
      return <Feedback />;
    }
    return false;
  }

  isMissingOrSubstitutedItems() {
    return this.props.orderDetails
      && (this.isMissingItems() || this.isSubstitutedItems());
  }

  isMissingItems() {
    return this.props.orderDetails
      && this.props.orderDetails.missingItems
      && this.props.orderDetails.missingItems.length > 0;
  }

  isSubstitutedItems() {
    return this.props.orderDetails
      && this.props.orderDetails.substitutedItems
      && this.props.orderDetails.substitutedItems.length > 0;
  }

  yourItems() {
    return this.props.orderDetails
      && this.props.orderDetails.pickedItems
      && this.props.orderDetails.pickedItems.length > 0;
  }

  hasOrderBeenPickedYet() {
    return this.props
      && this.props.orderDetails
      && (this.props.orderDetails.status === 'Awaiting Dispatch'
        || this.props.orderDetails.status === 'Enroute'
        || this.props.orderDetails.status === 'Delivered');
  }

  missingItemAccordionContents() {
    return (
      this.props.orderDetails.missingItems.map(missingItem => (
        <tr key={randomStr()}>
          <MissingItemsAccordionContents
            key={missingItem.skuCode}
            itemName={missingItem.description}
            itemSkuCode={missingItem.skuCode}
            itemQuantity={missingItem.quantityMissing}
          />
        </tr>
      ))
    );
  }

  substitutedItemContents() {
    return (
      this.props.orderDetails.substitutedItems.map(substitutedItem => (
        <tr key={randomStr()}>
          <MissingItemsAccordionContents
            key={substitutedItem.skuCode}
            itemName={substitutedItem.description}
            itemSkuCode={substitutedItem.skuCode}
            itemQuantity={substitutedItem.quantityPicked}
          />
        </tr>
      ))
    );
  }

  renderPickedItems() {
    return (
      this.props.orderDetails.pickedItems.map(pickedItem => [
        <tr key={randomStr()}>
          <th
            className="table-header width-forty"
            key={pickedItem.skuCode}
          >{pickedItem.categoryName}
          </th>
        </tr>,
        pickedItem.items.map(item => (
          <tr key={randomStr()}>
            <YourItemsAccordionContents
              key={item.skuCode}
              itemName={item.description}
              itemQuantity={item.quantityPicked}
              itemSkuCode={item.skuCode}
              itemPrice={item.unitPrice}
              itemTotalPrice={item.totalPrice}
            />
          </tr>
        )),
      ])
    );
  }

  renderAddress() {
    const addressString = [];

    if (
      this.props.orderDetails &&
      this.props.orderDetails.address &&
      this.props.orderDetails.address.building
    ) {
      addressString.push(this.props.orderDetails.address.building);
    }

    if (
      this.props.orderDetails &&
      this.props.orderDetails.address &&
      this.props.orderDetails.address.street
    ) {
      addressString.push(this.props.orderDetails.address.street);
    }

    return addressString.join(' ');
  }


  render() {
    if (this.state.loading) {
      return <LoadingSpinner />;
    } else if (this.props.errors) {
      store.dispatch(push({ pathname: `/error-screen/${this.props.errors && this.props.errors.response && this.props.errors.response.status}` }));
    }
    this.props.getDate(this.props.orderDetails && this.props.orderDetails.expectedDeliveryDate);
    return [
      <div key={randomStr()} className="content">
        {this.props.orderDetails && this.props.orderDetails.status && (
          <Timeline currentStatus={this.props.orderDetails.status.toLowerCase()} />
        )}
        {this.getFeedback()}
        <Grid
          container
          spacing={24}
        >
          <Grid item xs={12}>
            <Accordion
              title="Order Summary"
              data={
                <div className="full-width">
                  <table className="full-width bg-grey">
                    <thead>
                      <tr>
                        <th className="table-header width-fifteen hide-md" />
                        <th className="table-header width-fifteen" />
                        <th className="table-header width-twenty" />
                        <th className="table-header width-fifteen hide-md" />
                        <th className="table-header width-twenty hide-md" />
                        <th className="table-header width-fifteen hide-md" />
                      </tr>
                    </thead>
                    <tbody>
                      <OrderSummaryAccordionContents
                        key={randomStr()}
                        orderPlacedDate={
                        this.props &&
                        this.props.orderDetails &&
                        this.props.orderDetails.orderPlacedDate
                      }
                        custName={
                          this.props.orderDetails &&
                          this.props.orderDetails.customerName
                        }
                        custId={
                          this.props.orderDetails &&
                          this.props.orderDetails.customerId
                        }
                        address={
                        this.renderAddress()
                      }
                        city={
                        this.props.orderDetails &&
                        this.props.orderDetails.address &&
                    (this.props.orderDetails.address.town || this.props.orderDetails.address.county)
                      }
                        postCode={
                        this.props.orderDetails &&
                        this.props.orderDetails.address &&
                        this.props.orderDetails.address.zip
                      }
                        transactionId={
                        this.props &&
                        this.props.orderDetails &&
                        this.props.orderDetails.transactionId
                      }
                        exVat={
                        this.props &&
                        this.props.orderDetails &&
                        this.props.orderDetails.totalExcludingTaxAndDiscount
                          ? `£${this.props.orderDetails.totalExcludingTaxAndDiscount}`
                          : ''
                      }
                        vat={
                        this.props &&
                        this.props.orderDetails &&
                        this.props.orderDetails.vat
                          ? `£${this.props.orderDetails.vat}`
                          : ''
                      }
                      />
                    </tbody>
                  </table>
                </div>
            }
            />
            { this.isMissingOrSubstitutedItems() && this.hasOrderBeenPickedYet() &&
              <Accordion
                title="Missing Items"
                data={
                  <div className="full-width">
                    <InfoMessage
                      key={randomStr()}
                      message="We&#39;re sorry but some of the items
                      you ordered were out of stock therefore we may have delivered alternatives."
                    />
                    { this.isMissingItems() &&
                      <table
                        key={randomStr()}
                        className="full-width bg-grey"
                      >
                        <thead>
                          <tr>
                            <th className="table-header width-sixty">Unavailable</th>
                            <th className="table-header width-twenty">Sku</th>
                            <th className="table-header width-twenty">Quantity</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                          this.props &&
                          this.props.orderDetails && this.missingItemAccordionContents()
                        }
                        </tbody>
                      </table>
                    }
                    { this.isSubstitutedItems() &&
                      <table className="full-width bg-grey">
                        <thead>
                          <tr>
                            <th className="table-header border-top width-sixty">
                          Added
                            </th>
                            <th className="table-header width-twenty">Sku</th>
                            <th className="table-header width-twenty">Quantity</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.orderDetails && this.substitutedItemContents()}
                        </tbody>
                      </table>
                    }
                  </div>
                }
              />
            }
            { (!this.hasOrderBeenPickedYet() || this.yourItems()) &&
              <Accordion
                title="Your Items"
                data={
                  <div key={randomStr()} className="full-width">
                    { !this.hasOrderBeenPickedYet() &&
                      <InfoMessage
                        key={randomStr()}
                        message={['Your items will be displayed here once picked. To view your original order click ',
                          <a key={randomStr()} href="https://www.bestwaywholesale.co.uk/orders">here</a>]}
                      />
                    }
                    { this.hasOrderBeenPickedYet() &&
                      <table className="full-width bg-grey">
                        <thead>
                          <tr>
                            <th className="table-header width-forty" />
                            <th className="table-header width-fifteen">Quantity</th>
                            <th className="table-header width-fifteen hide-md">Sku</th>
                            <th className="table-header width-fifteen hide-md">Item Price</th>
                            <th className="table-header width-fifteen">Total Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.orderDetails && this.props.orderDetails.pickedItems &&
                          this.renderPickedItems()
                        }
                        </tbody>
                      </table>
                    }
                    { this.hasOrderBeenPickedYet() &&
                      <table
                        className="increased-width negative-bottom negative-left border-collapse"
                      >
                        <thead>
                          <tr className="footer bg-darkgrey">
                            <th className="width-sixty hide-md" />
                            <th className="width-twenty font-body--mobile">
                            Order (ex. VAT):
                            </th>
                            <th className="width-twenty font-body--mobile">
                            £{this.props.orderDetails.totalExcludingTaxAndDiscount}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="footer bg-green">
                            <th className="width-sixty hide-md" />
                            <th className="width-twenty font-body--mobile">Total:</th>
                            <th className="width-twenty font-body--mobile">
                            £{this.props.orderDetails.totalPrice}
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    }
                  </div>
                }
              />
            }
          </Grid>
        </Grid>
      </div>,
    ];
  }
}

OrderDetail.propTypes = {
  getOrderDetails: PropTypes.func,
  orderDetails: PropTypes.instanceOf(Object),
  params: PropTypes.instanceOf(Object),
  getDate: PropTypes.func.isRequired,
  getTime: PropTypes.func.isRequired,
  getStatus: PropTypes.func.isRequired,
  errors: PropTypes.string,
};

OrderDetail.defaultProps = {
  errors: '',
  getOrderDetails: '',
  orderDetails: '',
  params: '',
};

const mapStateToProps = state => ({
  orderDetails: state.order.orderDetails,
});

const mapDispatchToProps = {
  getOrderDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetail);



// WEBPACK FOOTER //
// src/components/organisms/OrderDetail/index.jsx